import { Spacing } from '@persona-id/design-tokens';
import { CircleAlertIcon } from '@persona-id/design-tokens/icons';
import { useCallback } from 'react';
import { BORDER_RADIUSES } from 'shared/styles/variables';
import styled from 'styled-components';

import CopyableField from 'dashboard/components/CopyableField';
import useToggle from 'lib/hooks/useToggle';

interface WebhookExpiringSecretBannerProps {
  value: string;
}

const WebhookExpiringSecretBanner = ({ value }: WebhookExpiringSecretBannerProps) => {
  const [expanded, { toggle }] = useToggle(false);

  const handleClick = useCallback(() => {
    return toggle();
  }, [toggle]);
  return (
    <StyledBanner>
      <StyledBannerContents role='button' onClick={handleClick} id='toggle-secret'>
        <CircleAlertIcon width={16} />
        <div style={{ marginLeft: '0.8em' }}>Expiring Secret</div>
        <div style={{ marginLeft: 'auto' }}>{expanded ? 'Hide' : 'Show'}</div>
      </StyledBannerContents>
      {expanded && (
        <StyledCopyableField
          id='webhook-show__expiring-secret'
          data-test='webhook-show__expiring-secret'
          type='password'
          value={value}
        />
      )}
    </StyledBanner>
  );
};

export default WebhookExpiringSecretBanner;

const StyledBanner = styled.div`
  background-color: ${({ theme }) => theme.color.variants.caution.highlightLight};
  padding: ${Spacing[4]};
  border-radius: ${BORDER_RADIUSES.rounded};
`;

const StyledCopyableField = styled(CopyableField)`
  background-color: #ffffff;
  margin-top: ${Spacing[3]};
`;

const StyledBannerContents = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
